/**
* DevExpress Dashboard (_mobile-layout-fullscreen-item.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import * as ko from 'knockout';
import { listFilterElement } from '../../viewer-parts/viewer-items/filter-items/_list-element';
import { ViewerItemFactory } from '../../viewer-parts/_viewer-item-factory';
import { types } from '../../viewer-parts/_viewer-item-types';
export class MobileItemViewerFactory extends ViewerItemFactory {
    createItem(container, options) {
        if (options.Type === types.comboBox)
            return new listFilterElement(container, options);
        return super.createItem(container, options);
    }
}
export class PopupResizeController {
    constructor(_repaintRequest) {
        this._repaintRequest = _repaintRequest;
        this._resizeHandler = null;
        this.onInitialized = (e) => {
            if (!this._resizeHandler) {
                this._resizeHandler = () => e.component.repaint();
                this._repaintRequest.add(this._resizeHandler);
            }
        };
        this.onDisposing = (e) => {
            this._resizeHandler && this._repaintRequest.remove(this._resizeHandler);
        };
    }
}
export var createFullscreenItemViewModel = (fullscreenItemModel, masterFilters, repaintRequest) => {
    var resizeController = new PopupResizeController(repaintRequest);
    return {
        itemViewModel: ko.computed(() => {
            var viewModel = fullscreenItemModel.viewModel();
            viewModel.repaintRequest = repaintRequest;
            return viewModel;
        }),
        visible: ko.computed(() => fullscreenItemModel.visible()),
        width: '100vw',
        height: '100%',
        onInitialized: resizeController.onInitialized,
        onDisposing: resizeController.onDisposing
    };
};
